// removed by extract-text-webpack-plugin
module.exports = {"mainContainer":"_1OnH2-H1T53c5LJduIxNkc","noneFoundMessage":"_1z-xqVzd_yBfNhI0-XE1ll","boldText":"_3XQ-DfTHDoFgN5xu2KxPY0","normalText":"_2uxIdvWkEMQoj1taBieexp","normalBoldText":"lVC6O9NUWmT253cT0-hAB","container":"A3swfEXTDYEsc9gyc29rU"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/RedirectToExternalURL/RedirectToExternalURL.scss
// module id = 2911
// module chunks = 0